module.exports = __webpack_public_path__ + "img/certOpas.3bc7826b.jpeg";